<template>
  <div class="col-6">
    <div :class="'border rounded p-3 ' + this.class" style="cursor: pointer">
      <div v-if="document">
        <div class="text-gray-700 fw-semibold ms-2">{{ types[document.type_id] ?? 'Неизвестный документ' }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomerDocumentCard',
  emits: [],
  props: {
    document: {
      type: Object,
      default: null
    },
    module: {
      type: Function,
      required: true
    },
    class: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      types: this.module.Client.documentType(0),
    }
  },
}
</script>

<style scoped>

</style>